var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBack = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 20,
  fill: "none",
  viewBox: "0 0 12 20",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M9.245 19.617c.248.248.563.383.935.383.745 0 1.342-.586 1.342-1.33 0-.372-.158-.71-.417-.97L3.213 9.99l7.892-7.69a1.38 1.38 0 0 0 .417-.969c0-.744-.598-1.33-1.342-1.33-.372 0-.687.135-.935.383L.474 8.952A1.44 1.44 0 0 0 0 10c0 .395.158.733.474 1.037z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgBack);
export default ForwardRef;